module.exports = __webpack_public_path__ + "img/subscription.abbc08f9.svg";